import { useQuery } from '@tanstack/react-query'
import {
	GetDailyPlayerReturnLossRequest,
	GetDailyPlayerReturnLossResponse,
} from '@/modules/promotion/type'
import { getDailyPlayerReturnLossList } from '../../services'
import { DailyPlayerReturnLossQueryKeys } from '@/modules/promotion/keys'

const useQueryGetDailyPlayerReturnLoss = (
	payload: GetDailyPlayerReturnLossRequest,
) => {
	return useQuery<GetDailyPlayerReturnLossResponse>({
		queryKey: [
			DailyPlayerReturnLossQueryKeys.GetDailyPlayerReturnLossList,
			payload,
		],
		queryFn: () => getDailyPlayerReturnLossList(payload),
	})
}

export default useQueryGetDailyPlayerReturnLoss
